import axios from "axios";
import React from "react";

const getaccessTokenSms = (newStr) => {
  const tokenRequestBody = {
    grant_type: "authorization_code",
    code: newStr,
    redirect_uri:`${window.location.origin}/setting`,
    client_id: process.env.REACT_APP_RING_CENTRAL_USER_ID,
    client_secret: process.env.REACT_APP_RING_CENTRAL_USER_SECRET,
  };
  
  async function read_extension_phone_number(accessToken) {
    try {
      axios
        .get(
          `${process.env.REACT_APP_RING_CENTRAL_URL}/restapi/v1.0/account/~/extension/~/phone-number`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          console.log(res?.data?.records?.[0]);
          localStorage.setItem(
            "ring_central_user_data",
            JSON.stringify(res?.data?.records?.[0])
          );
        });
    } catch (e) {
      return e;
    }
  }

  axios
    .post(
      `${process.env.REACT_APP_RING_CENTRAL_URL}/restapi/oauth/token`,
      tokenRequestBody,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Basic ${btoa(
            `${process.env.REACT_APP_RING_CENTRAL_USER_ID}:${process.env.REACT_APP_RING_CENTRAL_USER_SECRET}`
          )}`,
        },
      }
    )
    .then((response) => {
      const accessToken = response.data.access_token;
      const refreshToken = response.data.refresh_token;
      localStorage.setItem("ring_central_refresh_token", refreshToken);
      localStorage.setItem("ring_central_token", accessToken);
      read_extension_phone_number(accessToken);
    })
    .catch((error) => {
      if (error.response.data.error === "invalid_grant") {
        axios
          .post(
            `${process.env.REACT_APP_RING_CENTRAL_URL}/restapi/oauth/token`,
            `refresh_token=${localStorage.getItem(
              "ring_central_refresh_token"
            )}&grant_type=refresh_token&client_id=${
              process.env.REACT_APP_RING_CENTRAL_USER_ID
            }`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Basic ${btoa(
                  `${process.env.REACT_APP_RING_CENTRAL_USER_ID}:${process.env.REACT_APP_RING_CENTRAL_USER_SECRET}`
                )}`,
              },
            }
          )
          .then((response) => {
            const accessToken = response.data.access_token;
            const refreshToken = response.data.refresh_token;
            localStorage.setItem("ring_central_refresh_token", refreshToken);
            localStorage.setItem("ring_central_token", accessToken);
          });
      }
      return;
    });
};

export default getaccessTokenSms;
